import ArrowRight from "../../../assets/web/icons/ArrowRight";

export default function FeatureBulletPoint({ title }: { title: string }) {
  return (
    <div className="text-[#E56730] flex gap-4 items-center my-2 font-medium">
      <span className="text-sm">
        <ArrowRight />
      </span>
      <span>{title}</span>
    </div>
  );
}
